<template>
  <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
    <canvas :id="uuid" :width="size.width" :height="size.height" />
  </div>

  <div class="d-flex" :id="'chart_'+uuid" v-if="false">
    <div :id="uuid+'_legend'" >
      <div v-for="(element, index) in system_full" :key="element" class="mb-1">
        <v-avatar :color="palette[index+7]" size="30">
          <span style="font-size: 10px; z-index: 2; font-weight: bold;" :style="`color: ${Colorize(palette[index+7])}`">{{ element.split(' - ')[0] }}</span>
        </v-avatar>
        <span style="margin-left: -3px; padding-left: 10px;" :style="`border-bottom: 1px solid ${palette[index+7]}`">{{ element.split(' - ')[1] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import {Colorize, palette} from "@/libs/colorizer";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "f8c28d9e-1777-11eb-8116-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  data() {
    return {
      canvas: null,
      graph: null,
      system_full: [],
      system: [],
      count: []
    }
  },
  methods: {
    Colorize,
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.system,
            datasets: [{
              data: this.count,
              maxBarThickness: 800
            }]
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Процент работоспособности'
                },
              }
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end',
                formatter: function (value) {
                  if (value > 0) return Math.ceil(value)
                  return null
                }
              },
              autocolors: {
                mode: 'data',
                offset: 7
              },
              legend: {
                display: false
              },
            }
          }
        })
      }
    },
    update_data: function () {
      this.system_full = []
      this.system = []
      this.count = []

      for (let i =0; i < this.chart.report_data.length; i++) {
        this.system.push(this.chart.report_data[i]["ПодсистемаПРЕДСТАВЛЕНИЕ"].split(' - ')[0])
        this.system_full.push(this.chart.report_data[i]["ПодсистемаПРЕДСТАВЛЕНИЕ"])
        this.count.push(this.chart.report_data[i]["ПроцентРаботоспособности"])
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>